export default __webpack_public_path__ + "static/media/Retribution.6000f4c3.jpg";